// extracted by mini-css-extract-plugin
export var container = "_gw-1";
export var editor = "_gw-2";
export var resizable = "_gw-3";
export var wrapper = "_gw-0";